/**
 * Teacher of a moved lesson (LessonMove).
 * INHERIT: the teacher of the course segment that contains the original lesson (follows "ab dieser Stunde" changes).
 * OVERRIDE: LessonMove.teacher (null = vacant, e.g. while a substitution inquiry for the moved lesson is open).
 */
export enum LessonMoveTeacherMode {
    INHERIT = 'inherit',
    OVERRIDE = 'override',
}
